import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        pagination: {
          ITEMS_PER_PAGE: 'Items per page',
          OF: 'of',
          FIRST: 'First',
          LAST: 'Last',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        pagination: {
          ITEMS_PER_PAGE: 'Số mục mỗi trang',
          OF: 'của',
          FIRST: 'Trang đầu',
          LAST: 'Trang cuối',
        },
      },
    },
  }),
)
